import $, { map } from "jquery";
import compile from "@bd-utils/handlerbars-helper";
import BD_Component from "@bd-core/bd-component";
import CONFIG from "@bd-core/config";
import Screen from "@bd-utils/screen";
import Paintings from "@bd-utils/object";
import { getState } from "@bd-stores/store";
import { getRoomStatus } from "@bd-stores/game-progress";
import gsap from "gsap";
import Draggable from "gsap/Draggable";
import GameLogic from "@bd-core/game-logic";
export class MainRoom extends BD_Component {
    constructor() {
        super();

        this.id = "main-room";
        this.templateID = "main-room-template";

        this.elms = {
            btnOpenLadderRoom: ".js-open-ladder-room",
            background: ".js-screen-img",
            backgroundImage: ".screen__img",
            zoomIn: ".js-zoom-in",
            zoomOut: ".js-zoom-out",
            hintItem: ".js-hint",
            audioItem: ".js-audio",
            audioItemFile: ".js-audio-file",
            buttonItem: ".js-room-item-button",
            briefingItem: ".js-room-briefing",
            infoClose: ".js-info-close",
        };

        this._events = this.getEvents();

        this.startX = 0;
        this.startY = 0;
        this.zoom = 100;
        this.backgroundWidth = 5760;
        this.backgroundHeight = 2160;
    }

    /**
     * @returns {Array<BD_ComponentEvent>}
     */
    getEvents() {
        const elms = this.elms;
        return [
            {
                event: "click",
                selector: elms.btnOpenLadderRoom,
                handler: this.openLadderRoom,
            },
            {
                event: "click",
                selector: elms.zoomIn,
                handler: this.onZoomIn,
            },
            {
                event: "click",
                selector: elms.zoomOut,
                handler: this.onZoomOut,
            },
            {
                event: "change",
                selector: elms.hintItem,
                handler: this.onClickedHint,
            },
            {
                event: "click",
                selector: elms.audioItem,
                handler: this.onClickAudio,
            },
            {
                event: "click",
                selector: elms.buttonItem,
                handler: this.onClickButton,
            },
            {
                event: "click",
                selector: elms.infoClose,
                handler: this.onClickInfoClose,
            },
        ];
    }

    onClickInfoClose(e) {
        e.preventDefault();
        e.stopPropagation();

        const $info = $(".js-room-briefing");
        $info.removeClass("is-open");
    }

    onClickButton(e, el) {
        e.preventDefault();
        e.stopPropagation();

        const $el = $(el);
        const $briefing = $el.siblings(".js-room-briefing");
        $briefing.addClass("is-open");
    }

    openLadderRoom(e, el) {
        e.preventDefault();
        e.stopPropagation();

        const roomId = $(el).data("room-id");
        GameLogic.goToPage(roomId);
    }

    beforeInit() {
        window.screenCalculationFunc = () => {
            Screen.calculateCoverSize();
            Paintings.calculateCoverSize();
        };

        this.render();
        this.setGameState();
    }

    modifiedData() {
        const data = this._data;

        if (Object.keys(data).length == 0) return {};

        map(data.rooms, (room) => {
            let is_main_room = false;

            if (room.hotspot_type == "room") {
                is_main_room = true;
            }

            if (room.hotspot_type == "hint") {
                const font_fam = room.hint_font_family.split("|");
                const font_name = font_fam[0];
                const font_category = font_fam[1];

                room.font_family = `"${font_name}", ${font_category}`;
            }

            room.isMainRoom = is_main_room;

            return room;
        });

        let data_rooms = [];
        data.rooms.forEach((room) => {
            if (room.mainroom_id == data.room_id) {
                room.room_data = CONFIG.game.rooms.find(
                    (r) => r.id == room.room,
                )?.room;
                data_rooms.push(room);
            }
        });

        return {
            ...data,
            rooms: data_rooms,
        };
    }

    render() {
        const data = this.modifiedData();
        const mainroomStyle = data.mainroom_style;
        let templateID = "main-room-template";

        if (typeof mainroomStyle == "string") {
            templateID = mainroomStyle + "-template";
        }

        const htmlTemplate = $("#" + templateID).html();
        const html = compile(htmlTemplate, data);
        $(".app").html(html);
    }

    setGameState() {
        $(".js-room-completion").removeClass("is-open");

        const gameProgress = getState().gameProgress;
        const roomStatuses = gameProgress.roomStatus;
        let isAllRoomCompleted = true;

        const totalRooms = CONFIG.game.rooms.filter(
            (room) => room.type !== "main-room" && room.type !== "ladder-room",
        ).length;
        const completedRooms = Object.values(roomStatuses).filter(
            (status) => status === "is-status-completed",
        ).length;
        isAllRoomCompleted = completedRooms === totalRooms;

        if (isAllRoomCompleted) {
            $("#page-mainroom").addClass("is-room-completed");
        }

        this.updateRoomRequirements();

        $(this.elms.backgroundImage).on("load", () => {
            if ($(this.elms.backgroundImage).hasClass("js-draggable")) {
                this.initBackground();
                this.setMoveable();
                $(window).on("resize", () => {
                    this.resetDraggableParams();
                });
            }
        });
    }

    // ============================== CUSTOM FUNCTION

    initBackground() {
        let backWidth = $(this.elms.backgroundImage).prop("naturalWidth"),
            backHeight = $(this.elms.backgroundImage).prop("naturalHeight");
        this.backgroundWidth = !backWidth ? 4096 : backWidth;
        this.backgroundHeight = !backHeight ? 1536 : backHeight;
        setTimeout(() => {
            $(this.elms.backgroundImage).removeAttr("style");
            $(this.elms.background).removeAttr("style");
            $(".js-draggable").css({
                width: `${this.backgroundWidth}px`,
                height: `${this.backgroundHeight}px`,
            });
        }, 400);
    }

    resetDraggableParams() {
        $(".js-draggable").css({
            width: `${this.backgroundWidth}px`,
            height: `${this.backgroundHeight}px`,
            transform: `translate(-50%, -50%)`,
        });
        this.startX = 0;
        this.startY = 0;
        gsap.set(".js-draggable", { clearProps: "transform" });
    }

    onZoomIn() {
        if (this.zoom < 120) {
            this.zoom += 5;
            this.backgroundWidth += this.backgroundWidth * 0.05;
            this.backgroundHeight += this.backgroundHeight * 0.05;
            this.resetDraggableParams();
        }
    }

    onZoomOut() {
        if (this.zoom > 100) {
            this.zoom -= 5;
            this.backgroundWidth -= this.backgroundWidth * 0.05;
            this.backgroundHeight -= this.backgroundHeight * 0.05;
            this.resetDraggableParams();
        }
    }

    setMoveable() {
        gsap.registerPlugin(Draggable);
        let companions;

        Draggable.create(".js-draggable", {
            bounds: $(".screen__container"),
            dragResistance: 0.5,
            edgeResistance: 1,
            allowContextMenu: true,
            type: "x,y",
            zIndexBoost: false,
            onPress: function () {
                const screens = document.querySelectorAll(".js-draggable");
                let i = screens.length;
                companions = [];
                MainRoom.prototype.startX = this.x;
                MainRoom.prototype.startY = this.y;
                while (--i > -1) {
                    if (companions[i] !== this.target) {
                        companions.push({
                            element: screens[i],
                            x: gsap.getProperty(screens[i], "x"),
                            y: gsap.getProperty(screens[i], "y"),
                        });
                    }
                }
                gsap.killTweensOf(".js-draggable");
            },
            onDrag: function () {
                let i = companions.length,
                    deltaX = this.x - MainRoom.prototype.startX,
                    deltaY = this.y - MainRoom.prototype.startY,
                    companion;
                while (--i > -1) {
                    companion = companions[i];
                    gsap.set(companion.element, {
                        x: companion.x + deltaX,
                        y: companion.y + deltaY,
                    });
                }
            },
        });
    }

    updateRoomRequirements() {
        const rooms = CONFIG.game.rooms;

        $.each(rooms, (index, room) => {
            const requirements = room.requirements;
            const $roomItem = $(`.js-room-item[data-page="${room.id}"]`);

            $roomItem.removeClass("is-notready is-ready");

            if (!requirements.length) {
                $roomItem.addClass("is-ready").prop("disabled", false);
                return true;
            }

            let isLocked = false;
            $.each(requirements, (index, roomID) => {
                const roomStatus = getRoomStatus(roomID);

                if (roomStatus !== "is-status-completed") {
                    isLocked = true;
                    return false;
                }
            });

            isLocked
                ? $roomItem.addClass("is-notready").prop("disabled", true)
                : $roomItem.addClass("is-ready").prop("disabled", false);
        });
    }

    onClickedHint(e, el) {
        const elms = this.elms;
        const thisId = $(el).attr("id");
        const hintHotspots = $(elms.hintItem);

        $.each(hintHotspots, (index, item) => {
            const $item = $(item);
            const itemID = $item.attr("id");

            if (itemID !== thisId) {
                $item.prop("checked", false);
            }
        });
    }

    onClickAudio(e, el) {
        const elms = this.elms;
        const thisId = $(el).attr("id");
        const audioHotspot = $(elms.audioItem);

        $(elms.hintItem).prop("checked", false);

        const currentAudioID = "#" + thisId.split("audio-")[1];
        const $currAudio = $(currentAudioID).get(0);
        const isPlaying = $(el).hasClass("is-playing");

        // @ts-ignore
        isPlaying ? $currAudio.pause() : $currAudio.play();

        $(el).toggleClass("is-paused", isPlaying);
        $(el).toggleClass("is-playing", !isPlaying);

        $.each(audioHotspot, (index, item) => {
            const $item = $(item);
            const itemID = $item.attr("id");

            const audioID = "#" + itemID.split("audio-")[1];
            const $audio = $(audioID).get(0);

            if (itemID !== thisId) {
                // @ts-ignore
                if ($audio.play()) $audio.pause();

                $item.addClass("is-paused");
                $item.removeClass("is-playing");
            }
        });
    }
}
